module.exports = __webpack_public_path__ + "static/media/progress.5fdfa218.png";